module.exports = __webpack_public_path__ + "img/app-service.981cb0fd.svg";